window.IDPSystemMarketMap = {
  "version": "2026-09-16",
  "sectors": [
    {
      "id": "alimentacion",
      "label": "Alimentación y bebidas"
    },
    {
      "id": "quimico-farma",
      "label": "Industria química y farmacéutica"
    },
    {
      "id": "mecanica",
      "label": "Industria mecánica y automoción"
    },
    {
      "id": "logistica",
      "label": "Logística y almacenes"
    },
    {
      "id": "electronica",
      "label": "Electrónica y áreas ESD"
    },
    {
      "id": "sanitario",
      "label": "Sanidad, laboratorios y salas limpias"
    },
    {
      "id": "aparcamientos",
      "label": "Aparcamientos y movilidad"
    },
    {
      "id": "comercial",
      "label": "Comercial, oficinas y espacios públicos"
    },
    {
      "id": "deporte",
      "label": "Deporte, educación y confort"
    },
    {
      "id": "hidraulica",
      "label": "Obra hidráulica y contención"
    },
    {
      "id": "cubiertas",
      "label": "Cubiertas, energía y exterior"
    },
    {
      "id": "industria-general",
      "label": "Industria general y mantenimiento"
    }
  ],
  "needs": [
    {
      "id": "trafico-ligero",
      "label": "Tráfico ligero o medio"
    },
    {
      "id": "trafico-pesado",
      "label": "Tráfico pesado y abrasión"
    },
    {
      "id": "antideslizante-higienico",
      "label": "Antideslizamiento e higiene"
    },
    {
      "id": "quimica-inmersion",
      "label": "Resistencia química o inmersión"
    },
    {
      "id": "conductividad",
      "label": "Conductividad y control ESD"
    },
    {
      "id": "flexibilidad",
      "label": "Flexibilidad y puenteo de fisuras"
    },
    {
      "id": "confort-acustica",
      "label": "Confort, acústica y absorción"
    },
    {
      "id": "decorativo",
      "label": "Acabado decorativo"
    },
    {
      "id": "puesta-servicio-rapida",
      "label": "Puesta en servicio rápida"
    },
    {
      "id": "humedad-soporte",
      "label": "Humedad y regularización del soporte"
    },
    {
      "id": "impermeabilizacion",
      "label": "Impermeabilización continua"
    },
    {
      "id": "uv-exterior",
      "label": "Exposición UV y exterior"
    },
    {
      "id": "trafico-vehicular",
      "label": "Tráfico vehicular y aparcamientos"
    },
    {
      "id": "antigrafiti",
      "label": "Protección antigrafiti y antipóster"
    }
  ],
  "systems": {
    "idp-floor-ep-10": {
      "sectors": [
        "industria-general",
        "logistica",
        "mecanica"
      ],
      "needs": [
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción"
      ],
      "needLabels": [
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-10-v": {
      "sectors": [
        "industria-general",
        "logistica",
        "mecanica"
      ],
      "needs": [
        "humedad-soporte",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción"
      ],
      "needLabels": [
        "Humedad y regularización del soporte",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-10-w": {
      "sectors": [
        "alimentacion",
        "industria-general",
        "logistica",
        "mecanica",
        "sanitario"
      ],
      "needs": [
        "antideslizante-higienico",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción",
        "Sanidad, laboratorios y salas limpias"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-10-w-ab": {
      "sectors": [
        "alimentacion",
        "industria-general",
        "logistica",
        "mecanica",
        "sanitario"
      ],
      "needs": [
        "antideslizante-higienico",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción",
        "Sanidad, laboratorios y salas limpias"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-10-w-paramentos": {
      "sectors": [
        "alimentacion",
        "industria-general",
        "logistica",
        "mecanica",
        "sanitario"
      ],
      "needs": [
        "antideslizante-higienico",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción",
        "Sanidad, laboratorios y salas limpias"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-12-sl": {
      "sectors": [
        "industria-general",
        "logistica",
        "mecanica"
      ],
      "needs": [
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción"
      ],
      "needLabels": [
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-20": {
      "sectors": [
        "industria-general",
        "logistica",
        "mecanica"
      ],
      "needs": [
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción"
      ],
      "needLabels": [
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-20-cd": {
      "sectors": [
        "electronica",
        "industria-general",
        "logistica",
        "mecanica",
        "quimico-farma",
        "sanitario"
      ],
      "needs": [
        "conductividad",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Electrónica y áreas ESD",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción",
        "Industria química y farmacéutica",
        "Sanidad, laboratorios y salas limpias"
      ],
      "needLabels": [
        "Conductividad y control ESD",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-20-cd-deco": {
      "sectors": [
        "comercial",
        "electronica",
        "industria-general",
        "logistica",
        "mecanica",
        "quimico-farma",
        "sanitario"
      ],
      "needs": [
        "conductividad",
        "decorativo",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Comercial, oficinas y espacios públicos",
        "Electrónica y áreas ESD",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción",
        "Industria química y farmacéutica",
        "Sanidad, laboratorios y salas limpias"
      ],
      "needLabels": [
        "Conductividad y control ESD",
        "Acabado decorativo",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-20-decor-uv": {
      "sectors": [
        "comercial",
        "industria-general",
        "logistica",
        "mecanica"
      ],
      "needs": [
        "decorativo",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Comercial, oficinas y espacios públicos",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción"
      ],
      "needLabels": [
        "Acabado decorativo",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-20-os8": {
      "sectors": [
        "industria-general",
        "logistica",
        "mecanica",
        "quimico-farma"
      ],
      "needs": [
        "humedad-soporte",
        "quimica-inmersion",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción",
        "Industria química y farmacéutica"
      ],
      "needLabels": [
        "Humedad y regularización del soporte",
        "Resistencia química o inmersión",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-20-plus": {
      "sectors": [
        "industria-general",
        "logistica",
        "mecanica",
        "quimico-farma"
      ],
      "needs": [
        "quimica-inmersion",
        "trafico-ligero",
        "trafico-pesado"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción",
        "Industria química y farmacéutica"
      ],
      "needLabels": [
        "Resistencia química o inmersión",
        "Tráfico ligero o medio",
        "Tráfico pesado y abrasión"
      ]
    },
    "idp-floor-ep-20-r": {
      "sectors": [
        "alimentacion",
        "industria-general",
        "logistica",
        "mecanica"
      ],
      "needs": [
        "antideslizante-higienico",
        "trafico-ligero",
        "trafico-pesado"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Tráfico ligero o medio",
        "Tráfico pesado y abrasión"
      ]
    },
    "idp-floor-ep-20-w": {
      "sectors": [
        "alimentacion",
        "industria-general",
        "logistica",
        "mecanica",
        "sanitario"
      ],
      "needs": [
        "antideslizante-higienico",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción",
        "Sanidad, laboratorios y salas limpias"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-30": {
      "sectors": [
        "industria-general",
        "logistica",
        "mecanica"
      ],
      "needs": [
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción"
      ],
      "needLabels": [
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-30-ab": {
      "sectors": [
        "alimentacion",
        "industria-general",
        "logistica",
        "mecanica"
      ],
      "needs": [
        "antideslizante-higienico",
        "trafico-ligero",
        "trafico-pesado"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Tráfico ligero o medio",
        "Tráfico pesado y abrasión"
      ]
    },
    "idp-floor-ep-30-cd": {
      "sectors": [
        "electronica",
        "industria-general",
        "logistica",
        "mecanica",
        "quimico-farma",
        "sanitario"
      ],
      "needs": [
        "conductividad",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Electrónica y áreas ESD",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción",
        "Industria química y farmacéutica",
        "Sanidad, laboratorios y salas limpias"
      ],
      "needLabels": [
        "Conductividad y control ESD",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-30-deco-marmol": {
      "sectors": [
        "comercial",
        "industria-general",
        "logistica",
        "mecanica"
      ],
      "needs": [
        "decorativo",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Comercial, oficinas y espacios públicos",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción"
      ],
      "needLabels": [
        "Acabado decorativo",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-30-deco-metal": {
      "sectors": [
        "comercial",
        "industria-general",
        "logistica",
        "mecanica"
      ],
      "needs": [
        "decorativo",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Comercial, oficinas y espacios públicos",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción"
      ],
      "needLabels": [
        "Acabado decorativo",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-30-multicapa": {
      "sectors": [
        "alimentacion",
        "comercial",
        "quimico-farma",
        "sanitario"
      ],
      "needs": [
        "antideslizante-higienico",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Comercial, oficinas y espacios públicos",
        "Industria química y farmacéutica",
        "Sanidad, laboratorios y salas limpias"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-30-multicapa-ab": {
      "sectors": [
        "alimentacion",
        "comercial",
        "quimico-farma",
        "sanitario"
      ],
      "needs": [
        "antideslizante-higienico",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Comercial, oficinas y espacios públicos",
        "Industria química y farmacéutica",
        "Sanidad, laboratorios y salas limpias"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-ep-40": {
      "sectors": [
        "alimentacion",
        "industria-general",
        "logistica",
        "mecanica",
        "quimico-farma"
      ],
      "needs": [
        "antideslizante-higienico",
        "quimica-inmersion",
        "trafico-ligero",
        "trafico-pesado"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción",
        "Industria química y farmacéutica"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Resistencia química o inmersión",
        "Tráfico ligero o medio",
        "Tráfico pesado y abrasión"
      ]
    },
    "idp-floor-ep-mortar-15": {
      "sectors": [
        "industria-general",
        "logistica",
        "mecanica"
      ],
      "needs": [
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción"
      ],
      "needLabels": [
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pa-30": {
      "sectors": [
        "industria-general"
      ],
      "needs": [
        "puesta-servicio-rapida",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Puesta en servicio rápida",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pas-10": {
      "sectors": [
        "industria-general"
      ],
      "needs": [
        "puesta-servicio-rapida",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Puesta en servicio rápida",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pas-20": {
      "sectors": [
        "industria-general"
      ],
      "needs": [
        "puesta-servicio-rapida",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Puesta en servicio rápida",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pu-10": {
      "sectors": [
        "industria-general"
      ],
      "needs": [
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pu-10-sport": {
      "sectors": [
        "deporte",
        "industria-general"
      ],
      "needs": [
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Deporte, educación y confort",
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pu-10-w": {
      "sectors": [
        "alimentacion",
        "industria-general",
        "sanitario"
      ],
      "needs": [
        "antideslizante-higienico",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Industria general y mantenimiento",
        "Sanidad, laboratorios y salas limpias"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pu-10-w-sport": {
      "sectors": [
        "alimentacion",
        "deporte",
        "industria-general",
        "sanitario"
      ],
      "needs": [
        "antideslizante-higienico",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Deporte, educación y confort",
        "Industria general y mantenimiento",
        "Sanidad, laboratorios y salas limpias"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pu-20": {
      "sectors": [
        "industria-general"
      ],
      "needs": [
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pu-20-deco": {
      "sectors": [
        "comercial",
        "industria-general"
      ],
      "needs": [
        "decorativo",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Comercial, oficinas y espacios públicos",
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Acabado decorativo",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pu-20-flex": {
      "sectors": [
        "industria-general"
      ],
      "needs": [
        "flexibilidad",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pu-20-flex-asf": {
      "sectors": [
        "industria-general"
      ],
      "needs": [
        "flexibilidad",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pu-20-r": {
      "sectors": [
        "alimentacion",
        "industria-general"
      ],
      "needs": [
        "antideslizante-higienico",
        "trafico-ligero",
        "trafico-pesado"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Tráfico ligero o medio",
        "Tráfico pesado y abrasión"
      ]
    },
    "idp-floor-pu-20-w-sport": {
      "sectors": [
        "alimentacion",
        "deporte",
        "industria-general",
        "sanitario"
      ],
      "needs": [
        "antideslizante-higienico",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Deporte, educación y confort",
        "Industria general y mantenimiento",
        "Sanidad, laboratorios y salas limpias"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pu-30": {
      "sectors": [
        "industria-general"
      ],
      "needs": [
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pu-30-comfort": {
      "sectors": [
        "deporte",
        "industria-general"
      ],
      "needs": [
        "confort-acustica",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Deporte, educación y confort",
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Confort, acústica y absorción",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pu-30-flex-asf": {
      "sectors": [
        "industria-general"
      ],
      "needs": [
        "flexibilidad",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pu-30-flex-e": {
      "sectors": [
        "industria-general"
      ],
      "needs": [
        "flexibilidad",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pu-30-flex-i": {
      "sectors": [
        "industria-general"
      ],
      "needs": [
        "flexibilidad",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-pu-40-deco-ext-peatonal-vehicular": {
      "sectors": [
        "alimentacion",
        "aparcamientos",
        "comercial",
        "industria-general"
      ],
      "needs": [
        "antideslizante-higienico",
        "decorativo",
        "humedad-soporte",
        "trafico-ligero",
        "trafico-pesado",
        "trafico-vehicular"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Aparcamientos y movilidad",
        "Comercial, oficinas y espacios públicos",
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Acabado decorativo",
        "Humedad y regularización del soporte",
        "Tráfico ligero o medio",
        "Tráfico pesado y abrasión",
        "Tráfico vehicular y aparcamientos"
      ]
    },
    "idp-floor-pu-40-eco": {
      "sectors": [
        "alimentacion",
        "industria-general"
      ],
      "needs": [
        "antideslizante-higienico",
        "trafico-ligero",
        "trafico-pesado"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Tráfico ligero o medio",
        "Tráfico pesado y abrasión"
      ]
    },
    "idp-floor-pu-40-safety": {
      "sectors": [
        "alimentacion",
        "industria-general"
      ],
      "needs": [
        "antideslizante-higienico",
        "trafico-ligero",
        "trafico-pesado"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Tráfico ligero o medio",
        "Tráfico pesado y abrasión"
      ]
    },
    "idp-floor-pua-30-park": {
      "sectors": [
        "alimentacion",
        "aparcamientos",
        "industria-general",
        "logistica",
        "mecanica"
      ],
      "needs": [
        "antideslizante-higienico",
        "flexibilidad",
        "puesta-servicio-rapida",
        "trafico-ligero",
        "trafico-pesado",
        "trafico-vehicular"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Aparcamientos y movilidad",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Flexibilidad y puenteo de fisuras",
        "Puesta en servicio rápida",
        "Tráfico ligero o medio",
        "Tráfico pesado y abrasión",
        "Tráfico vehicular y aparcamientos"
      ]
    },
    "idp-floor-pua-h-30-park": {
      "sectors": [
        "alimentacion",
        "aparcamientos",
        "industria-general",
        "logistica",
        "mecanica"
      ],
      "needs": [
        "antideslizante-higienico",
        "flexibilidad",
        "puesta-servicio-rapida",
        "trafico-ligero",
        "trafico-pesado",
        "trafico-vehicular"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Aparcamientos y movilidad",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Flexibilidad y puenteo de fisuras",
        "Puesta en servicio rápida",
        "Tráfico ligero o medio",
        "Tráfico pesado y abrasión",
        "Tráfico vehicular y aparcamientos"
      ]
    },
    "idp-floor-pua-h-sl-30": {
      "sectors": [
        "industria-general",
        "logistica",
        "mecanica"
      ],
      "needs": [
        "flexibilidad",
        "puesta-servicio-rapida",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Puesta en servicio rápida",
        "Tráfico ligero o medio"
      ]
    },
    "idp-floor-puc-30-4-mm": {
      "sectors": [
        "alimentacion",
        "industria-general",
        "logistica",
        "mecanica",
        "quimico-farma"
      ],
      "needs": [
        "antideslizante-higienico",
        "quimica-inmersion",
        "trafico-ligero",
        "trafico-pesado"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción",
        "Industria química y farmacéutica"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Resistencia química o inmersión",
        "Tráfico ligero o medio",
        "Tráfico pesado y abrasión"
      ]
    },
    "idp-floor-puc-40-safety-4-mm": {
      "sectors": [
        "alimentacion",
        "industria-general",
        "logistica",
        "quimico-farma"
      ],
      "needs": [
        "antideslizante-higienico",
        "quimica-inmersion",
        "trafico-ligero",
        "trafico-pesado"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria química y farmacéutica"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Resistencia química o inmersión",
        "Tráfico ligero o medio",
        "Tráfico pesado y abrasión"
      ]
    },
    "idp-floor-puc-30-6-mm": {
      "sectors": [
        "alimentacion",
        "industria-general",
        "logistica",
        "mecanica",
        "quimico-farma"
      ],
      "needs": [
        "antideslizante-higienico",
        "quimica-inmersion",
        "trafico-ligero",
        "trafico-pesado"
      ],
      "sectorLabels": [
        "Alimentación y bebidas",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción",
        "Industria química y farmacéutica"
      ],
      "needLabels": [
        "Antideslizamiento e higiene",
        "Resistencia química o inmersión",
        "Tráfico ligero o medio",
        "Tráfico pesado y abrasión"
      ]
    },
    "idp-proof-pu-2k-m-green-roof": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "uv-exterior"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Exposición UV y exterior"
      ]
    },
    "idp-proof-pu-2k-m-plus": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "flexibilidad",
        "impermeabilizacion"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Impermeabilización continua"
      ]
    },
    "idp-proof-pu-2k-m-radon-gas-shield": {
      "sectors": [
        "cubiertas",
        "industria-general",
        "quimico-farma",
        "sanitario"
      ],
      "needs": [
        "impermeabilizacion",
        "quimica-inmersion"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior",
        "Industria general y mantenimiento",
        "Industria química y farmacéutica",
        "Sanidad, laboratorios y salas limpias"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Resistencia química o inmersión"
      ]
    },
    "idp-proof-pu-basic": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Tráfico ligero o medio"
      ]
    },
    "idp-proof-pu-cool-roof": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "uv-exterior"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Exposición UV y exterior"
      ]
    },
    "idp-proof-pu-deco": {
      "sectors": [
        "comercial",
        "cubiertas"
      ],
      "needs": [
        "decorativo",
        "impermeabilizacion"
      ],
      "sectorLabels": [
        "Comercial, oficinas y espacios públicos",
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Acabado decorativo",
        "Impermeabilización continua"
      ]
    },
    "idp-proof-pu-deco-pavistone": {
      "sectors": [
        "comercial",
        "cubiertas"
      ],
      "needs": [
        "decorativo",
        "impermeabilizacion"
      ],
      "sectorLabels": [
        "Comercial, oficinas y espacios públicos",
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Acabado decorativo",
        "Impermeabilización continua"
      ]
    },
    "idp-proof-pu-green-roof": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "uv-exterior"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Exposición UV y exterior"
      ]
    },
    "idp-proof-pu-impermax-strat": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua"
      ]
    },
    "idp-proof-pu-inverted": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "uv-exterior"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Exposición UV y exterior"
      ]
    },
    "idp-proof-pu-park": {
      "sectors": [
        "aparcamientos",
        "cubiertas"
      ],
      "needs": [
        "flexibilidad",
        "impermeabilizacion",
        "trafico-pesado",
        "trafico-vehicular"
      ],
      "sectorLabels": [
        "Aparcamientos y movilidad",
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Impermeabilización continua",
        "Tráfico pesado y abrasión",
        "Tráfico vehicular y aparcamientos"
      ]
    },
    "idp-proof-pu-plus": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "flexibilidad",
        "impermeabilizacion"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Impermeabilización continua"
      ]
    },
    "idp-proof-pu-pool": {
      "sectors": [
        "cubiertas",
        "hidraulica"
      ],
      "needs": [
        "impermeabilizacion",
        "quimica-inmersion"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior",
        "Obra hidráulica y contención"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Resistencia química o inmersión"
      ]
    },
    "idp-proof-pu-protec-1": {
      "sectors": [
        "cubiertas",
        "quimico-farma"
      ],
      "needs": [
        "impermeabilizacion",
        "quimica-inmersion"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior",
        "Industria química y farmacéutica"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Resistencia química o inmersión"
      ]
    },
    "idp-proof-pu-protec-2": {
      "sectors": [
        "cubiertas",
        "quimico-farma"
      ],
      "needs": [
        "impermeabilizacion",
        "quimica-inmersion"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior",
        "Industria química y farmacéutica"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Resistencia química o inmersión"
      ]
    },
    "idp-proof-pu-spray": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida"
      ]
    },
    "idp-proof-pu-spray-green-roof": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "uv-exterior"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Exposición UV y exterior"
      ]
    },
    "idp-proof-pu-w": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Tráfico ligero o medio"
      ]
    },
    "idp-proof-pu-water-tank": {
      "sectors": [
        "cubiertas",
        "hidraulica",
        "quimico-farma"
      ],
      "needs": [
        "impermeabilizacion",
        "quimica-inmersion",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior",
        "Obra hidráulica y contención",
        "Industria química y farmacéutica"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Resistencia química o inmersión",
        "Tráfico ligero o medio"
      ]
    },
    "idp-proof-pua-basic": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Tráfico ligero o medio"
      ]
    },
    "idp-proof-pua-cool-roof": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "uv-exterior"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Exposición UV y exterior"
      ]
    },
    "idp-proof-pua-h-aluminium": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "uv-exterior"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Exposición UV y exterior"
      ]
    },
    "idp-proof-pua-h-basic": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Tráfico ligero o medio"
      ]
    },
    "idp-proof-pua-h-bridge": {
      "sectors": [
        "aparcamientos",
        "cubiertas"
      ],
      "needs": [
        "flexibilidad",
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "trafico-pesado",
        "trafico-vehicular"
      ],
      "sectorLabels": [
        "Aparcamientos y movilidad",
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Tráfico pesado y abrasión",
        "Tráfico vehicular y aparcamientos"
      ]
    },
    "idp-proof-pua-h-foam-aluminium": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "uv-exterior"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Exposición UV y exterior"
      ]
    },
    "idp-proof-pua-h-green-roof": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "uv-exterior"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Exposición UV y exterior"
      ]
    },
    "idp-proof-pua-h-park": {
      "sectors": [
        "aparcamientos",
        "cubiertas"
      ],
      "needs": [
        "flexibilidad",
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "trafico-pesado",
        "trafico-vehicular"
      ],
      "sectorLabels": [
        "Aparcamientos y movilidad",
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Tráfico pesado y abrasión",
        "Tráfico vehicular y aparcamientos"
      ]
    },
    "idp-proof-pua-h-plus": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "flexibilidad",
        "impermeabilizacion",
        "puesta-servicio-rapida"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Impermeabilización continua",
        "Puesta en servicio rápida"
      ]
    },
    "idp-proof-pua-h-plus-s": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "flexibilidad",
        "impermeabilizacion",
        "puesta-servicio-rapida"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Impermeabilización continua",
        "Puesta en servicio rápida"
      ]
    },
    "idp-proof-pua-h-stadium": {
      "sectors": [
        "cubiertas",
        "deporte"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "uv-exterior"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior",
        "Deporte, educación y confort"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Exposición UV y exterior"
      ]
    },
    "idp-proof-pua-impermax-strat": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida"
      ]
    },
    "idp-proof-pua-inverted": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "uv-exterior"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Exposición UV y exterior"
      ]
    },
    "idp-proof-pua-m-basic": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Tráfico ligero o medio"
      ]
    },
    "idp-proof-pua-m-park": {
      "sectors": [
        "aparcamientos",
        "cubiertas"
      ],
      "needs": [
        "flexibilidad",
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "trafico-pesado",
        "trafico-vehicular"
      ],
      "sectorLabels": [
        "Aparcamientos y movilidad",
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Tráfico pesado y abrasión",
        "Tráfico vehicular y aparcamientos"
      ]
    },
    "idp-proof-pua-m-plus": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "flexibilidad",
        "impermeabilizacion",
        "puesta-servicio-rapida"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Impermeabilización continua",
        "Puesta en servicio rápida"
      ]
    },
    "idp-proof-pua-m-supreme": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "flexibilidad",
        "impermeabilizacion",
        "puesta-servicio-rapida"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Impermeabilización continua",
        "Puesta en servicio rápida"
      ]
    },
    "idp-proof-pua-nmdc-geo-lake": {
      "sectors": [
        "cubiertas",
        "hidraulica"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "quimica-inmersion"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior",
        "Obra hidráulica y contención"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Resistencia química o inmersión"
      ]
    },
    "idp-proof-pua-park": {
      "sectors": [
        "aparcamientos",
        "cubiertas"
      ],
      "needs": [
        "flexibilidad",
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "trafico-pesado",
        "trafico-vehicular"
      ],
      "sectorLabels": [
        "Aparcamientos y movilidad",
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Tráfico pesado y abrasión",
        "Tráfico vehicular y aparcamientos"
      ]
    },
    "idp-proof-pua-plus": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "flexibilidad",
        "impermeabilizacion",
        "puesta-servicio-rapida"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Impermeabilización continua",
        "Puesta en servicio rápida"
      ]
    },
    "idp-proof-pua-pool": {
      "sectors": [
        "cubiertas",
        "hidraulica"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "quimica-inmersion"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior",
        "Obra hidráulica y contención"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Resistencia química o inmersión"
      ]
    },
    "idp-proof-pua-protec-1": {
      "sectors": [
        "cubiertas",
        "quimico-farma"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "quimica-inmersion"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior",
        "Industria química y farmacéutica"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Resistencia química o inmersión"
      ]
    },
    "idp-proof-pua-protec-2": {
      "sectors": [
        "cubiertas",
        "quimico-farma"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "quimica-inmersion"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior",
        "Industria química y farmacéutica"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Resistencia química o inmersión"
      ]
    },
    "idp-proof-pua-radon-gas-shield": {
      "sectors": [
        "cubiertas",
        "industria-general",
        "quimico-farma",
        "sanitario"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "quimica-inmersion"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior",
        "Industria general y mantenimiento",
        "Industria química y farmacéutica",
        "Sanidad, laboratorios y salas limpias"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Resistencia química o inmersión"
      ]
    },
    "idp-proof-pua-shield": {
      "sectors": [
        "cubiertas",
        "industria-general",
        "sanitario"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior",
        "Industria general y mantenimiento",
        "Sanidad, laboratorios y salas limpias"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida"
      ]
    },
    "idp-proof-pua-water-tank": {
      "sectors": [
        "cubiertas",
        "hidraulica",
        "quimico-farma"
      ],
      "needs": [
        "impermeabilizacion",
        "puesta-servicio-rapida",
        "quimica-inmersion",
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior",
        "Obra hidráulica y contención",
        "Industria química y farmacéutica"
      ],
      "needLabels": [
        "Impermeabilización continua",
        "Puesta en servicio rápida",
        "Resistencia química o inmersión",
        "Tráfico ligero o medio"
      ]
    },
    "idp-proof-pua-x5": {
      "sectors": [
        "cubiertas"
      ],
      "needs": [
        "flexibilidad",
        "impermeabilizacion",
        "puesta-servicio-rapida"
      ],
      "sectorLabels": [
        "Cubiertas, energía y exterior"
      ],
      "needLabels": [
        "Flexibilidad y puenteo de fisuras",
        "Impermeabilización continua",
        "Puesta en servicio rápida"
      ]
    },
    "idp-floor-epoxy-100-antipolvo": {
      "sectors": [
        "comercial",
        "industria-general",
        "logistica",
        "mecanica"
      ],
      "needs": [
        "trafico-ligero"
      ],
      "sectorLabels": [
        "Comercial, oficinas y espacios públicos",
        "Industria general y mantenimiento",
        "Logística y almacenes",
        "Industria mecánica y automoción"
      ],
      "needLabels": [
        "Tráfico ligero o medio"
      ]
    },
    "sistema-idp-ag-rev": {
      "sectors": [
        "comercial",
        "industria-general"
      ],
      "needs": [
        "antigrafiti",
        "uv-exterior"
      ],
      "sectorLabels": [
        "Comercial, oficinas y espacios públicos",
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Protección antigrafiti y antipóster",
        "Exposición UV y exterior"
      ]
    },
    "sistema-idp-ag-per": {
      "sectors": [
        "comercial",
        "industria-general"
      ],
      "needs": [
        "antigrafiti",
        "uv-exterior"
      ],
      "sectorLabels": [
        "Comercial, oficinas y espacios públicos",
        "Industria general y mantenimiento"
      ],
      "needLabels": [
        "Protección antigrafiti y antipóster",
        "Exposición UV y exterior"
      ]
    }
  }
};
